import { getData } from 'conversations-async-data/async-data/operators/getters';
import { createSelector } from 'reselect';
import { getCurrentAsyncConnectedAccounts } from './getCurrentAsyncConnectedAccounts';
export const getAllConnectedAccounts = createSelector([getCurrentAsyncConnectedAccounts], getData);